
import HCLTreeVertex from '../HCLTreeNode/HCLTreeVertex';
import HCLTreeMxVertexHandler from './HCLTreeMxVertexHandler';
import {mxCylinder, mxRectangleShape, mxShape, mxUtils} from "mxgraph-js";

class BayesianNetworkMxVertexHandler extends HCLTreeMxVertexHandler {
  createSelectionShape(bounds: any): mxRectangleShape {
    // // @ts-ignore
    // this.container.setAttribute('tabindex', '-1');
    // // @ts-ignore
    // this.container.focus();
    function RoundRectShape() { }
    RoundRectShape.prototype = new mxShape();
    RoundRectShape.prototype.constructor = RoundRectShape;
    mxUtils.extend(RoundRectShape, mxCylinder);
    // @ts-ignore
    RoundRectShape.prototype.redrawPath = (c, x, y, w, h) => {
      c.ellipse(0, 0, w, h);
      c.fillAndStroke();
    };
    // @ts-ignore
    const shape = new RoundRectShape();
    const color = '#ff5f4a';
    shape.fill = `${color}16`;
    shape.stroke = `${color}88`;
    shape.strokewidth = '2';
    return shape;
  }
}


export default BayesianNetworkMxVertexHandler;
